export default __webpack_public_path__ + "static/media/blue.8add7ace.png";